// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__-OrgF","inputWrap":"CustomTip_inputWrap__yep3M"};